import { AppView, ButtonView, LiveTableView, TitlebarView, VideoView, VideoControlBarView, LivescoreWidget,
         LivesettlementsWidget, LivetableWidget, StatisticsRankingWidget, StatisticsTeamformWidget, StatisticsHead2headWidget,
         TimeoutEvent, View } from "@gaming/srvg-classes-core";
import { OverlayView } from "../OverlayContainerView/OverlayView";
import { MatchdayArea } from "../MatchdayArea";
import { WIDGET_LIVETABLE, WIDGET_STATISTICS_TEAMFORM, WIDGET_STATISTICS_RANKING,
         WIDGET_LIVESETTLEMENTS, WIDGET_LIVESCORE, WIDGET_STATISTICS_HEAD2HEAD } from "@gaming/srvg-classes-core";

/**
 * Main view class for the VBL collapsed version.
 */
export class CollapsedView extends AppView {
    guiSwitch: ButtonView;
    liveTable: LiveTableView; // FIXME why is there a livetableview and a widgetlivetableview???
    overlayContainerView: OverlayView;
    titlebar: TitlebarView;
    videoView: VideoView;
    videoControlBar: VideoControlBarView;
    widgetLivescore: LivescoreWidget;
    widgetLivesettlements: LivesettlementsWidget;
    widgetLivetable: LivetableWidget;
    widgetStatisticsRanking: StatisticsRankingWidget;
    widgetStatisticsTeamform: StatisticsTeamformWidget;
    widgetStatisticsTeamformExtendedBetting: StatisticsTeamformWidget;
    widgetStatisticsHead2headExtendedBetting: StatisticsHead2headWidget;
    matchdayArea: MatchdayArea;

    videoControlBarTimeout: any;

    constructor(options){
        options = options || {};
        options.selector = options.selector || '#vbl_container';
        super(options);

        /******************* initialize views ************************/

        this.titlebar = this.addSubView( new TitlebarView( { selector: '#titlebar' } ) );

        var hdChannel = null;
        if( srvg.videooptions.alt_videobasename ) {
            if( !srvg.featuresInstances.getStartWithHd() ) {
                hdChannel = srvg.videooptions.serverurl+srvg.videooptions.videobasename;
            }
            else {
                hdChannel = srvg.videooptions.serverurl+srvg.videooptions.alt_videobasename;
            }
        }

        // Setting the videoHandlers order for the videoView
        var videoHandlers = [];
        if (srvg.Player.getWorkingStreamType() == 'flash') {
            videoHandlers = ['flash', 'hls', 'html5'];
        } else {
            videoHandlers = ['hls', 'flash', 'html5'];
        }

        this.videoView = this.addSubView( new VideoView( {
            playerOptions: {
                hdChannel: hdChannel,
                hdswitch: null,
                overlays: '#overlay',
                useLiveplayer: true,
                hidePlayButton: false,
                hideStopButton: true,
                hide:'display',
                muted: srvg.featuresInstances.getDisableAudioByDefault() || srvg.videooptions.startMute,
                vod: false,
                loglevel: 0,
                ui: {
                    enabled: true,
                    videoControls : false,
                    fullscreen : false,
                    controlBarHideDelay: 3
                },
                poster: srvg.url.image+'video/poster.png',
                noButton: false,
                autoplay: true,
                swf: srvg.url.webroot+'liveplayer/srplayer.swf',
                scaleMode: 'stretch',
                videoHandlers: videoHandlers,
                smoothTransition: false,
                gui: {'use': true, 'position': 'left'}
            }
        },srvg ) );

        this.videoControlBar = this.addSubView( new VideoControlBarView( { selector: '#videocontrolbar' } ) );

        this.videoControlBar.playpauseButton.$domNode.addClass( 'enabled' );
        if( srvg.videooptions.alt_videobasename ) {
            this.videoControlBar.hdButton.$domNode.addClass( 'enabled' );
            if (!srvg.featuresInstances.getStartWithHd()) {
                this.videoControlBar.hdButton.$domNode.addClass( 'pressed' );
            }
        }
        this.videoControlBar.soundButton.$domNode.addClass( 'enabled' );
        if( srvg.featuresInstances.getDisableAudioByDefault() || srvg.videooptions.startMute || localStorage.getItem('livePlayerVolume') == "0" ) {
            this.videoControlBar.soundButton.$domNode.addClass( 'pressed' );
        }

        this.guiSwitch = this.addSubView( new ButtonView( { selector: '#gui_switch_button' } ) );

        this.liveTable = this.addSubView(new LiveTableView({
            liveTableWrapper: '#live_table_wrapper',
            liveTable: '#live_table',
            viewWrapper: '#wrapper',
            animationDuration: 200,
            videoWrapper: '#videoView',
            shouldSetDimension: true
        }));

        this.widgetLivetable = null;
        this.widgetStatisticsTeamform = null;
        this.widgetStatisticsRanking = null;
        this.widgetLivesettlements = null;
        this.widgetLivescore = null;

        if (srvg.widgets.enabled && (window as any).vswidgets.init ) {
            srvg.widgetLoader = (window as any).vswidgets.init({});
            var widgetList = [];
            var widgetGroup = 'VBL';

            if( srvg.widgets[WIDGET_LIVETABLE].enabled ) {
                this.widgetLivetable = this.addSubView(new LivetableWidget({ view: 'collapsed', widgetGroup: widgetGroup })); // FIXME rename view parameter to something that is not a framework concept
                widgetList.push( this.widgetLivetable );
            }
            if( srvg.widgets[WIDGET_STATISTICS_TEAMFORM].enabled ) {
                this.widgetStatisticsTeamform = this.addSubView( new StatisticsTeamformWidget({ widgetGroup: widgetGroup, platform: 'overlay-small' }) );
                widgetList.push( this.widgetStatisticsTeamform );
            }
            if( srvg.widgets[WIDGET_STATISTICS_RANKING].enabled ) {
                this.widgetStatisticsRanking = this.addSubView( new StatisticsRankingWidget({ widgetGroup: widgetGroup, platform: 'overlay-small' }) );
                widgetList.push( this.widgetStatisticsRanking );
            }
            if( srvg.widgets[WIDGET_LIVESETTLEMENTS].enabled &&  !srvg.featuresInstances.getDisableOdds()) {
                this.widgetLivesettlements = this.addSubView( new LivesettlementsWidget({ widgetGroup: widgetGroup, platform: 'overlay-small' }) );
                widgetList.push( this.widgetLivesettlements );
            }
            if( srvg.widgets[WIDGET_LIVESCORE].enabled ) {
                this.widgetLivescore = this.addSubView(new LivescoreWidget({
                    singlePlayButton: false, widgetGroup: widgetGroup, showRaceToX: false}));
                widgetList.push( this.widgetLivescore );
            }

            if (srvg.config.extendedBetting){
                if(srvg.widgets[WIDGET_STATISTICS_TEAMFORM].enabled){
                    this.widgetStatisticsTeamformExtendedBetting = this.addSubView( new StatisticsTeamformWidget({
                        widgetGroup: widgetGroup, element: '#statistics_extendedbetting_teamform'
                    }) );
                    widgetList.push( this.widgetStatisticsTeamformExtendedBetting );
                }
                if (srvg.widgets[WIDGET_STATISTICS_HEAD2HEAD].enabled){
                    this.widgetStatisticsHead2headExtendedBetting = this.addSubView( new StatisticsHead2headWidget({
                        widgetGroup: widgetGroup,
                        element: '#statistics_extendedbetting_head2head'
                    }) );
                    widgetList.push( this.widgetStatisticsHead2headExtendedBetting );
                }
            }

            srvg.eventExchange.addEventHandler(widgetList, 'all', 'addWidget', 'handleAddWidgetEvent');
            srvg.eventExchange.addEventHandler(widgetList, 'all', 'destroyWidget', 'handleDestroyWidgetEvent');
            srvg.eventExchange.addEventHandler( widgetList, app.inactivityController, TimeoutEvent );
        }

        this.overlayContainerView = this.addSubView( new OverlayView( { selector: '#overlay_container' } ) );
        this.overlayContainerView.push( new View( { selector: '#overlay_layer_pre_match_1' } ), 'pre_match_1' );
        this.overlayContainerView.push( new View( { selector: '#overlay_layer_pre_match_2' } ), 'pre_match_2' );
        this.overlayContainerView.push(
            new View({selector: '#overlay_layer_pre_match_extended_betting'}), 'pre_match_extendedBetting'
        );

        //show only the live settlement overlay, if the odds are disabled
        if(!srvg.featuresInstances.getDisableOdds()){
            this.overlayContainerView.push( new View( { selector: '#overlay_layer_post_match'  } ), 'post_match' );
        }
        //this.overlayContainerView.push( new SrvgView( { selector: '#overlay_layer_post_season' } ), 'post_season' );

        this.matchdayArea = this.addSubView( new MatchdayArea({
            hasMatchdayPicker: true,
            hasOddsGallery: true,
            oddsGallery: {
                numberOfItemsToShow: 6,
                animationTime: 0,
                clickAnimationFadeTime: 0,
                activateAwesomeFloat: false
            },
            clock: {
                layout:     '<span class="clock-min">{mnn}</span><span class="clock-sep">{sep}</span>' +
                    '<span class="clock-sec">{snn}</span>',
                hourLayout: '<span class="clock-hrs">{hnn}</span>' +
                    '<span class="clock-sep">{sep}</span><span class="clock-min">{mnn}</span>' +
                    '<span class="clock-sep">{sep}</span><span class="clock-sec">{snn}</span>'
            }
        }) );
        var that = this;
        this.videoControlBarTimeout = window.setTimeout( function() { that.videoControlBar.hide(); }, srvg.config.videoControlBar.showTime );

        $('#right_outer_column').mousemove( function() {
            if( ! that.videoControlBar.isShown ) {
                that.videoControlBar.show();
            }
            if( that.videoControlBarTimeout ) {
                window.clearTimeout( that.videoControlBarTimeout );
            }
            that.videoControlBarTimeout = window.setTimeout( function() { that.videoControlBar.hide(); that.videoControlBarTimeout = null; }, srvg.config.videoControlBar.showTime );
        } );
    }
}